import React, { useEffect, useState } from "react";
import { Papercontainer } from "@rewardle/apps.ui.papercontainer.papercontainer";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import styled from "@emotion/styled";
import { Link as LinkRouter, useNavigate } from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";
import AddFilled from "../../assets/icons/AddFilled.png";
import axios from "axios";
import {
  OutlinedInput as MuiOutlinedInput,
  Table,
  TableBody,
  TableHead,
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  Typography as MuiTypography,
  Button as MuiButton,
  IconButton,
  Alert,
  Radio,
  DialogContent
} from "@mui/material";

import Loader from "../../components/loader/loader";
import { spacing, SpacingProps } from "@mui/system";
import { CircularProgress } from "@mui/material";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "../../components/modal/ModalPage";

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}
const Button = styled(MuiButton)<ButtonProps>(spacing);

const Typography = styled(MuiTypography)``;
const TableCell = styled(MuiTableCell)``;
const TableCellHeading = styled(MuiTableCell)`
  color: var(--light-text-primary, #192f67);
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.17px;
  width: 20px;
`;

const TableCellColumn = styled(MuiTableCell)`
color: var(--light-text-secondary, rgba(0, 0, 0, 0.60));
font-family: Montserrat,sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 400;
line - height: normal;
`;

const TableRow = styled(MuiTableRow)``;

const CustomTableRow = styled(MuiTableRow)`
  &:hover {
    background-color: #f2f5f9;
    cursor: pointer;
  }
`;

const CustomTablePagination: any = styled(TablePagination)`
  .MuiTablePagination-selectLabel {
    color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
    font-feature-settings: "clig" off, "liga" off;
  }
`;

const TypographyBreadcrumbsButtonContainer = styled(MuiTypography)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const CustomButton: any = styled(MuiButton)`
  margin-top: 10px;
  &.blue_button {
    background-color: blue;
  }

  &.custom_disabled {
    background-color: grey !important;
  }
`;

interface LabelDisplayedRowsArgs {
  from: number;
  to: number;
  count: number;
}

const Staffs = () => {
  const navigate = useNavigate();
  let currentBusiness: any = localStorage?.getItem("currentBusiness");
  const state: any = {
    token: localStorage?.getItem("businessAccessToken"),
    currentBusiness: currentBusiness ? JSON.parse(currentBusiness) : null
  };

  const [listOfStaffs, setListOfStaffs] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const initialLoadingStates: boolean[] = listOfStaffs.map(() => false);
  const [loading, setLoading] = useState(initialLoadingStates);
  const [open, setOpen] = useState(false);
  const [errorsMessage, setErrorsMessage] = useState("");
  const [getStaffDetail, setStaffDetail] = useState<any>("");
  const [isBusinessIdChange, setIsBusinessIdChange] = useState(false);

  const handleStaffsDataWithPagination = (
    response: {
      data: { Items: string | any[]; Count: any; LastEvaluatedKey: any };
    },
    page: number,
    rowsPerPage: number,
    isTakeOldData?: boolean
  ) => {
    let oldData = isTakeOldData ? [...listOfStaffs] : [];
    let startIndex = rowsPerPage * (page + 1) - rowsPerPage;
    let endIndex = rowsPerPage * (page + 1);
    const slicedData = response?.data?.Items.slice(startIndex, endIndex);
    let newIndexData = {
      Count: response?.data?.Count,
      Items: slicedData,
      LastEvaluatedKey: response?.data?.LastEvaluatedKey
    };
    oldData.push(newIndexData);
    setListOfStaffs(oldData);
    return null;
  };

  const [confirmMainContactOpen, setConfirmMainContactOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState<any>(null);
  const [mainContactloading, setMainContactloading] = useState(false);

  const getTransactionsList = (page = currentPage, isTakeOldData = true) => {
    setIsLoading(true);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/datacollectionbusiness/business/staff?businessid=${state?.currentBusiness?.BusinessId}&pagesize=${rowsPerPage}`,
      headers: {
        Authorization: "Bearer " + state?.token,
        "Content-Type": "application/json"
      }
    };

    axios
      .request(config)
      .then((response) => {
        handleStaffsDataWithPagination(
          response,
          page,
          rowsPerPage,
          isTakeOldData
        );
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (state?.currentBusiness?.BusinessId) {
      setCurrentPage(0);
      setRowsPerPage(10);
      setListOfStaffs([]);
      setIsBusinessIdChange(!isBusinessIdChange);
    }
  }, [state?.currentBusiness?.BusinessId]);

  useEffect(() => {
    if (rowsPerPage) getTransactionsList();
  }, [rowsPerPage, isBusinessIdChange]);

  const handleChangeRowsPerPage = (event?: any) => {
    setRowsPerPage(parseInt(event?.target?.value, 10));
    setCurrentPage(0);
    setListOfStaffs([]);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > currentPage) {
      getTransactionsList(newPage);
    } else {
      let oldData = [...listOfStaffs];
      const slicedData = oldData?.slice(0, newPage + 1);
      setListOfStaffs(slicedData);
    }
    setCurrentPage(newPage);
  };

  const labelDisplayedRows = ({ from, to, count }: LabelDisplayedRowsArgs) => {
    if (listOfStaffs[currentPage]?.LastEvaluatedKey) {
      return `${from}-${to} of more than ${count}`;
    } else {
      return `${from}-${to} of ${count}`;
    }
  };
  const handlWelcomeEmailForStaff = (data: any, index: number) => {
    const newLoadingStates = [...loading];
    newLoadingStates[index] = true;
    setLoading(newLoadingStates);
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/users/user/sendwelcomeemail?businessid=${state?.currentBusiness?.BusinessId}`;
    const valueData = {
      Email: data?.Email
    };
    axios
      .post(apiUrl, valueData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state?.token}`
        }
      })
      .then((response) => {
        console.log(response);
        setStaffDetail(valueData);
        loading[index] = false;
        setLoading(loading);
        setOpen(true);
      })

      .catch((error) => {
        console.log(error);
        setErrorsMessage("Email is not sent to:");
        loading[index] = false;
        setLoading(loading);
      });
  };

  const handleMainContactChange = (row: any) => {
    setSelectedStaff(row);
    setConfirmMainContactOpen(true);
  };

  const updateMainContactStaffDetails = () => {
    setMainContactloading(true);
    let requestBody = { ...selectedStaff };
    requestBody.IsMainContact = true;
    let data = JSON.stringify(requestBody);

    let config: any = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/datacollectionbusiness/business/staff?businessid=${state?.currentBusiness?.BusinessId}`,
      headers: {
        Authorization: `bearer ${state?.token}`,
        "Content-Type": "application/json"
      },
      data: data
    };

    axios
      .request(config)
      .then(() => {
        setCurrentPage(0);
        setRowsPerPage(10);
        setListOfStaffs([]);
        setMainContactloading(false);
        setConfirmMainContactOpen(false);
        getTransactionsList(0, false);
      })
      .catch(() => {
        setMainContactloading(false);
      });
  };

  return (
    <React.Fragment>
      {errorsMessage && (
        <div style={{ marginTop: "2px", marginBottom: "1px" }}>
          <Alert severity="error">{errorsMessage}</Alert>
        </div>
      )}
      <Breadcrumbs
        heading="Staff Members"
        subHeading="Manage your staff"
        docs={
          <Button
            component={LinkRouter}
            to="/staff"
            variant="contained"
            color="secondary"
            mt={2}
            className="blue_button"
          >
            <TypographyBreadcrumbsButtonContainer>
              <img src={AddFilled} alt="" />
              Add a new staff
            </TypographyBreadcrumbsButtonContainer>
          </Button>
        }
      />

      <Papercontainer elevation={0}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div style={{ width: "100%", overflowX: "auto" }}>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCellHeading align="left">
                      Main Contact
                    </TableCellHeading>
                    <TableCellHeading align="left">FirstName</TableCellHeading>
                    <TableCellHeading align="left">LastName</TableCellHeading>
                    <TableCellHeading align="left">Position</TableCellHeading>
                    <TableCellHeading align="left">Mobile</TableCellHeading>
                    <TableCellHeading align="left">Email</TableCellHeading>
                    <TableCellHeading align="left">Pin</TableCellHeading>
                    <TableCellHeading align="left">Status</TableCellHeading>
                    <TableCellHeading align="left">SendInvite</TableCellHeading>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listOfStaffs?.length > 0 ? (
                    listOfStaffs[currentPage]?.Items?.map(
                      (row: any, index: any) => (
                        <CustomTableRow
                          key={index}
                          onClick={(e: any) => {
                            e.stopPropagation();
                            localStorage.setItem(
                              "staffDetails",
                              JSON.stringify(row)
                            );
                            navigate(`/staff/${row.BusinessId}`);
                          }}
                        >
                          <TableCellColumn align="left">
                            <Radio
                              checked={row?.IsMainContact ? true : false}
                              onClick={(e: any) => {
                                e.stopPropagation();
                                handleMainContactChange(row);
                              }}
                              value={row?.IsMainContact ? true : false}
                              name="mainContact"
                              sx={{
                                "&.Mui-checked": {
                                  color: "#223354"
                                }
                              }}
                            />
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.FirstName ? row?.FirstName : "-"}
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.LastName ? row?.LastName : "-"}
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.Position ? row?.Position : "-"}
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.Mobile ? row?.Mobile : "-"}
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.Email ? row?.Email : "-"}
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.Pin ? row?.Pin : "-"}
                          </TableCellColumn>
                          <TableCellColumn align="left">
                            {row?.IsActive ? "Active" : "Inactive"}
                          </TableCellColumn>
                          <TableCellColumn align="left" key={index}>
                            {loading[index] ? (
                              <CircularProgress
                                size={20}
                                style={{ marginLeft: "10px" }}
                              />
                            ) : (
                              <IconButton
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  handlWelcomeEmailForStaff(row, index);
                                }}
                              >
                                <ForwardToInboxIcon />
                              </IconButton>
                            )}
                          </TableCellColumn>
                        </CustomTableRow>
                      )
                    )
                  ) : (
                    <TableCell
                      colSpan={3}
                      align="center"
                      style={{ borderBottom: "none" }}
                    >
                      <Typography variant="body1" mt={2}>
                        {"No Data Available"}
                      </Typography>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </div>
            {listOfStaffs?.length > 0 && (
              <CustomTablePagination
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={listOfStaffs[currentPage]?.Count}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                nextIconButtonProps={{
                  disabled: !listOfStaffs[currentPage]?.LastEvaluatedKey
                }}
                labelDisplayedRows={labelDisplayedRows}
              />
            )}
          </>
        )}
        <Modal open={open} setOpen={setOpen}>
          <DialogTitle sx={{ m: 2, p: 2 }} id="customized-dialog-title">
            Email is successfully sent to : {getStaffDetail?.Email}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
        </Modal>

        <Modal
          open={confirmMainContactOpen}
          setOpen={setConfirmMainContactOpen}
        >
          <DialogTitle>
            Do you want to set {selectedStaff?.FirstName}{" "}
            {selectedStaff?.LastName} as main contact?
          </DialogTitle>
          <DialogContent sx={{ display: "flex", gap: "10px" }}>
            <CustomButton
              variant="contained"
              color="secondary"
              mt={4}
              className={`blue_button`}
              onClick={() => updateMainContactStaffDetails()}
            >
              {mainContactloading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Yes"
              )}
            </CustomButton>
            <CustomButton
              variant="contained"
              color="secondary"
              mt={4}
              className={`blue_button`}
              onClick={() => setConfirmMainContactOpen(false)}
            >
              {"No"}
            </CustomButton>
          </DialogContent>
        </Modal>
      </Papercontainer>
    </React.Fragment>
  );
};

export default Staffs;
